/** @jsxRuntime classic */
/** @jsx jsx */

import { Builder } from '@builder.io/react';
import { jsx } from '@emotion/react';
import { Fragment, ReactElement, useEffect } from 'react';
import { usePrevious } from '../../hooks/usePrevious';
import { useABTestContext } from '../ABTest/ABTest';

type Props = {
  children: ReactElement;
  preview: boolean;
  variantName: string;
};

export function ABVariant({ children, preview, variantName }: Props) {
  const { activeVariant, registerVariant, deregisterVariant } =
    useABTestContext();
  const previousVariantName = usePrevious(variantName);

  const isPreviewMode = Builder.isEditing || Builder.isPreviewing;

  useEffect(() => {
    if (isPreviewMode) {
      return;
    }

    if (variantName) {
      registerVariant(variantName);
    }

    if (previousVariantName && previousVariantName !== variantName) {
      deregisterVariant(previousVariantName);
    }

    return () => {
      deregisterVariant(variantName);
    };
  }, [
    variantName,
    registerVariant,
    deregisterVariant,
    isPreviewMode,
    previousVariantName,
  ]);

  const shouldShowVariant = () => {
    if (isPreviewMode) return preview;
    return variantName === activeVariant?.name;
  };

  if (!shouldShowVariant()) return <Fragment />;

  return <Fragment>{children}</Fragment>;
}
